<template>
	<div class="home-page">
		
		<van-overlay :show="uploading">
			<div style="position: absolute;width: 100%;top: 45%;left: 0;">
				<div class="upload-overlay">
					<van-loading type="spinner" color="#fff" />
					<div class="upload-text">{{ uploadProgress }}</div>
				</div>
			</div>
			
		</van-overlay>

		<div v-if="showDetail" class="detail-wrapper">
			<Detail :option-id="currentOptionId" :voteid="voteid" :wxopenid="wxopenid"
				:voteStartsign="vote_startsign" @back="onDetailBack"
				@voted="onDetailVoted" @vote-limit="onVoteLimit" />
		</div>

		<div v-if="!showDetail" class="page-bg">
			<div class="top-img-view">
				<img src="@/assets/new/top_bg.jpg" class="top-img" />
				<div class="tab-bar">
					<img src="@/assets/new/tab1.png" :class="['tab-img', { 'tab-active': activeTab === 1 }]"
						@click="switchTab(1)" />
					<img src="@/assets/new/tab2.png" :class="['tab-img', { 'tab-active': activeTab === 2 }]"
						@click="switchTab(2)" />
					<img src="@/assets/new/tab3.png" :class="['tab-img', { 'tab-active': activeTab === 3 }]"
						@click="switchTab(3)" />
				</div>
			</div>



			<div v-show="activeTab === 1" class="tab-content">
				<div class="intro-section">
					<img src="@/assets/new/intro.png" style="width: 90%;" />
				</div>
			</div>

			<div v-show="activeTab === 2" class="tab-content">

				<div class="form-section">
					<div style="position: relative;font-size: 0;">
						<img src="../assets/new/form_bg.png" style="width: 100%;" />
					</div>
					<div class="form-card">
						<div class="form-item">
							<div class="form-item-label">作品名称</div>
							<div class="input-div">
								<input type="text" v-model="form.zpname" placeholder="请输入" class="custom-input" />
							</div>
						</div>
						<div class="form-item">
							<div class="form-item-label">版权登记号</div>
							<div class="input-div">
								<input type="text" v-model="form.isbn" placeholder="请输入" class="custom-input" />
							</div>
						</div>
						

						<div class="form-item">
							<div class="form-item-label">姓名/单位名称</div>
							<div class="input-div">
								<input type="text" v-model="form.username" placeholder="请输入" class="custom-input" />
							</div>
						</div>
						<div class="form-item">
							<div class="form-item-label">身份证号码/社会信用代码</div>
							<div class="input-div">
								<input type="text" v-model="form.idnum" placeholder="请输入" class="custom-input" />
							</div>
						</div>
						<div class="form-item">
							<div class="form-item-label">地区</div>
							<div class="input-div">
								<input type="text" v-model="form.cityname" readonly @click="cityShow=true" placeholder="请选择" class="custom-input" />
							</div>
							<van-popup v-model="cityShow" round position="bottom">
								<van-cascader
									v-model="cityValue"
									title="请选择所在地区"
									:options="cityOptions"
									:field-names="fieldNames"
									@close="cityShow = false"
									@finish="onFinish"
								/>
							</van-popup>
						</div>

						<div class="form-item">
							<div class="form-item-label">联系电话</div>
							<div class="input-div">
								<input type="text" v-model="form.phone" placeholder="请输入" class="custom-input" />
								
							</div>
						</div>

						<div class="form-tip">
							为便于后续沟通事宜，请提供联系方式。我们将严格遵守相关法律法规，对您提供的信息予以保密。
						</div>

						<div class="form-item" style="margin-top: 15px;">
							<div class="form-item-label">作品类别</div>
							<div class="input-div">
								<input type="text" v-model="zpcategoryValue" readonly @click="subcategoryShow=true" placeholder="请选择" class="custom-input" />
							</div>
							<van-popup v-model="subcategoryShow" round position="bottom">
								<van-cascader
									v-model="subcategoryValue"
									title="请选择作品类别"
									:options="subcategoryOptions"
									:field-names="subcategoryFieldNames"
									@close="subcategoryShow = false"
									@finish="subcategoryOnFinish"
								/>
							</van-popup>
						</div>

						<div class="form-item" style="margin-top: 20px;">
							<div class="form-item-label">作品上传</div>
							<div class="input-div"></div>
						</div>
						<div class="form-upload-tip">
							<div style="width: 3rem;">要求：</div>
							<div style="width: 0;flex: 1;text-align: justify;">文字提交PDF，图片提交JPG/PNG(不低于300dpi)，视频提交MP4(1080P及以上)，音频提交MP3。</div>
						</div>
						<div style="margin-top: 15px;">
							<van-uploader 
								v-model="fileList"
								:after-read="(file) => afterRead(file, form.subcategory)"
								:accept="zpAccept"
								:multiple="false"
								:max-size="maxSize"
								:max-count="1"
								@oversize="oversize"
								upload-icon="plus"
								:disabled="zpcategoryValue==null?true:false"
							/>
						</div>
						
						<div v-if="form.subcategory!='摄影作品'">
							<div class="form-item" style="margin-top: 20px;">
								<div class="form-item-label">封面上传</div>
								<div class="input-div"></div>
							</div>
							<div class="form-upload-tip">
								<div style="">封面仅用于投票页面展示。</div>
							</div>
							<div style="margin-top: 15px;">
								<van-uploader 
									v-model="posterFileList"
									:after-read="(file) => afterRead(file, '封面')"
									accept="image/*"
									:multiple="false"
									:max-size="10*1024*1024"
									:max-count="1"
									@oversize="oversize"
									upload-icon="plus"
									:disabled="zpcategoryValue==null?true:false"
								/>
							</div>
						</div>
						

						<div class="form-item" style="margin-top: 20px;">
							<div class="form-item-label">荣誉证明</div>
							<div class="input-div"></div>
						</div>
						<div style="margin-top: 15px;">
							<van-uploader 
								v-model="ryFileList"
								:after-read="(file) => afterRead(file, '荣誉证明')"
								accept=".PDF,.pdf"
								:multiple="false"
								:max-size="10*1024*1024"
								:max-count="1"
								@oversize="oversize"
								upload-icon="plus"
							/>
						</div>
						
						<div class="form-item" style="margin-top: 20px;">
							<div class="form-item-label">补充材料</div>
							<div class="input-div"></div>
						</div>
						<div style="margin-top: 15px;">
							<van-uploader 
								v-model="bcFileList"
								:after-read="(file) => afterRead(file, '补充材料')"
								accept=".PDF,.pdf"
								:multiple="false"
								:max-size="10*1024*1024"
								:max-count="1"
								@oversize="oversize"
								upload-icon="plus"
							/>
						</div>
						
						<div class="form-item" style="margin-top: 20px;">
							<div class="form-item-label">作品简介</div>
							<div class="input-div"></div>
						</div>
						<div style="margin-top: 15px;">
							<van-field v-model="form.zpintroduction" show-word-limit :maxlength="1000" type="textarea" placeholder="(1000字内，说明创作思路与主题关联)" rows="4"
								class="custom-textarea" />
						</div>
						
						
						<div class="submit-btn" @click="tijiao">
							<img src="@/assets/new/submit_btn.png" style="width: 50%;" />
						</div>
					</div>
					<div style="position: relative;font-size: 0;">
						<img src="../assets/new/form_bg3.png" style="width: 100%;" />
					</div>
				</div>

				
			</div>

			<div v-show="activeTab === 3" class="tab-content">
				<div style="margin: 0 5%;">
					<div style="position: relative;font-size: 0;">
						<img src="../assets/new/list_bg.png" style="width: 100%;" />
					</div>
					<div class="search-section">
						<div style="font-size: 1rem;color: #000;text-indent: 2rem;line-height: 1.8;">
							活动期间，每位用户每天可投5票。可将5票集中投给单一作品，或自由分配给多个作品。</div>
						<div class="inputsr">
							<input type="text" v-model="hotKeyword" placeholder="请输入姓名或者序号进行搜索" />
							<img @click="onHotSearch" src="../assets/new/search_icon.png" />
						</div>
					</div>
					<div class="list-wrapper">
						<div class="list-inner">
							<van-list v-model="hotLoading" :finished="hotFinished" finished-text="没有更多了"
								@load="onHotLoad">
								<div class="list-container">
									<div v-for="(item, index) in hotList" :key="'hot-' + item.option_id" class="listdiv"
										:style="{ marginLeft: index % 2 === 0 ? '0' : '2%' }"
										@click="goDetail(item.option_id)">
										<div class="xuhao">{{item.option_num}}</div>
										<div class="coverss"
											:style="{ background: 'url(' + item.option_pic + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"
											></div>
										<div class="list-info">
											<div class="titlewz">{{ item.option_author }}</div>
											<div class="titlewz">{{ item.option_title }}</div>
											
											<template v-if="item.vote_startsign === 'yes'">
												<div class="piaodiv">
													<span>{{item.option_vnum}}</span><span style="color: #fff;margin-left: 5px;">票</span>
												</div>
												<div style="text-align: center;">
													<img src="@/assets/new/vote_btn.png" class="vote-btn"
														@click.stop="handleVote(item.option_id)" />
												</div>
												
											</template>
										</div>
									</div>
								</div>
							</van-list>
						</div>
					</div>
				</div>

			</div>
		</div>

		<!-- <van-back-top bottom="60" /> -->
	</div>
</template>

<script>
	import Toast from 'vant/lib/toast'
	import 'vant/lib/toast/style';
	import Detail from './detail.vue'
	import {
		getVoteList,
		searchVoteList,
		uploadImage,
		uploadFile,
		submitEntry,
		visitLog,
		getCityList,
		getSubcategoryList,
		getBigFileUploadUrl
	} from '@/api'
	import {
		getQueryString,
		isJiyun
	} from '@/utils'

	export default {
		name: 'Home',
		components: {
			Detail
		},
		data() {
			return {
				sign_file_url:'',
				
				cityShow:false,
				cityValue:null,
				cityOptions:[],
				
				
				
				vote_startsign:'no',
				activeTab: 1,
				voteid: null,
				wxopenid: '',
				uploading: false,
				uploadProgress: '',
				picurl: '',
				workPicurl: '',
				honorPicurl: '',
				supplementPicurl: '',
				showDetail: false,
				currentOptionId: '',
				scrollTop: 0,
				
				zpcategoryValue:null,
				form: {
					zpname:"",
					isbn:"",
					username:"",
					idnum:"",
					cityname:"",
					phone:"",
					zpcategory:"",
					subcategory:"",
					zpcoverimg:"",
					zpurl:"",
					honor:"",
					buchongfile:"",
					zpintroduction:""
				},
				hotKeyword: '',
				hotList: [],
				hotPage: 1,
				hotLoading: false,
				hotFinished: false,
				hotSearchMode: false,
				sxflag: false,
				
				fieldNames: {
					text: 'cityname',
					value: 'cityid',
					children: 'children'
				},
				
				
				subcategoryShow:false,
				subcategoryValue:null,
				subcategoryOptions:[],
				subcategoryFieldNames: {
					text: 'categoryname',
					value: 'categoryid',
					children: 'subcategorylist'
				},
				
				
				zpFileName:null,
				honorFileName:null,
				supplementFileName:null,
				
				
				fileList:[],
				posterFileList:[],
				ryFileList:[],
				bcFileList:[],
			}
		},
		computed: {
			zpAccept(){
				
				if (this.form.subcategory=='文字作品'||this.form.subcategory=='计算机软件'||this.form.subcategory=='其他作品') {
					return '.PDF,.pdf';
				} else if (this.form.subcategory=='口述作品'||this.form.subcategory=='音乐作品'){
					return '.MP3,.mp3';
				} else if (this.form.subcategory=='视频作品'){
					return '.MP4,.mp4';
				}else{
					return 'image/*';
				}
			},
			maxSize(){
				if (this.form.subcategory=='文字作品'||this.form.subcategory=='计算机软件'||this.form.subcategory=='其他作品') {
					return 20*1024*1024
				} else if (this.form.subcategory=='口述作品'||this.form.subcategory=='音乐作品'){
					return 20*1024*1024
				} else if (this.form.subcategory=='视频作品'){
					return 800*1024*1024
				}else{
					return 20*1024*1024
				}
			}
		},
		created() {
			this.initParams()
			this.handleOptionid()
			visitLog()
			this.onHotLoad()
			this.getCity()
			this.getSubcategory()
		},
		methods: {
			oversize(){
				Toast('文件过大')
			},
			afterRead(file,subcategory){
				console.log("afterRead:",file)
				this.uploading = true
				this.uploadProgress = '已上传0%'
				if(subcategory=='视频作品'){
					getBigFileUploadUrl().then(res => {
						
						this.sign_file_url = res.data
						uploadFile(file.file, subcategory, (progressEvent) => {
							if (progressEvent.lengthComputable) {
								var percent = Math.round(progressEvent.loaded / progressEvent.total * 100)
								this.uploadProgress = '已上传' + percent + '%'
							}
						},this.sign_file_url).then(res => {
							
							let video_url = this.sign_file_url.split('?')[0]
							this.form.zpurl = video_url.split("https://yanfa-upload-1330455741.cos.ap-beijing.myqcloud.com/")[1]
							Toast('上传完成')
							this.uploading = false
						}).catch(() => {
							Toast('上传失败')
							this.fileList=[];
							this.uploading = false
						})
					}).catch(() => {
						Toast('上传失败')
						this.fileList=[];
						this.uploading = false
					})
				}else{
					uploadFile(file.file, subcategory, (progressEvent) => {
						if (progressEvent.lengthComputable) {
							var percent = Math.round(progressEvent.loaded / progressEvent.total * 100)
							this.uploadProgress = '已上传' + percent + '%'
						}
					}).then(res => {
						
						let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
						console.log("file-data:",data.code)
						if (data.code == 1) {
							if (subcategory=='荣誉证明') {
								this.form.honor = data.data.picurl
							} else if (subcategory=='补充材料') {
								this.form.buchongfile = data.data.picurl
							} else if (subcategory=='封面'){
								this.form.zpcoverimg = data.data.picurl
							} else {
								this.form.zpurl = data.data.picurl
							}
							
							// this.fileList = [{ url: this.form.zpurl }]
							Toast('上传完成')
						} else {
							Toast(data.msg || '上传失败')
							if (subcategory=='荣誉证明') {
								this.ryFileList=[];
							} else if (subcategory=='补充材料') {
								this.bcFileList=[];
							} else if (subcategory=='封面'){
								this.posterFileList=[];
							} else {
								this.fileList=[];
							}
						}
						this.uploading = false
					}).catch(() => {
						Toast('上传失败')
						if (subcategory=='荣誉证明') {
							this.ryFileList=[];
						} else if (subcategory=='补充材料') {
							this.bcFileList=[];
						} else if (subcategory=='封面'){
							this.posterFileList=[];
						} else {
							this.fileList=[];
						}
						this.uploading = false
					})
				}
				
			},
			
			getSubcategory(){
				getSubcategoryList().then(res => {
					let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					let subcategoryOptions = []
					for (let index = 0; index < data.data.length; index++) {
						
						let subcategorylist = []
						for (let j = 0; j < data.data[index].subcategorylist.length; j++) {
							
							subcategorylist.push({
								categoryid: data.data[index].subcategorylist[j].subcategoryid,
								categoryname : data.data[index].subcategorylist[j].subcategoryname
							})
						}
						subcategoryOptions.push({
							categoryid: data.data[index].categoryid,
							categoryname : data.data[index].categoryname,
							subcategorylist: subcategorylist
						})
					}
					this.subcategoryOptions = subcategoryOptions
				})
			},
			subcategoryOnFinish({ selectedOptions }) {
				this.subcategoryShow = false;
				this.form.zpcategory = selectedOptions[0].categoryname
				this.form.subcategory = selectedOptions[1].categoryname
				this.zpcategoryValue = this.form.zpcategory+'  '+this.form.subcategory
				this.fileList=[]
			},
			
			getCity(){
				getCityList().then(res => {
					let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					this.cityOptions = data.data
				})
			},
			onFinish({ selectedOptions }) {
				this.cityShow = false;
				this.form.cityname = selectedOptions.map((option) => option.cityname).join('/');
			},
			initParams() {
				this.wxopenid = getQueryString('openid')
				var voteid = getQueryString('voteid')
				if (voteid) this.voteid = voteid
			},
			
			handleOptionid() {
				var optionid = getQueryString('optionid')
				if (optionid) {
					this.goDetail(optionid)
				}
			},
			switchTab(tab) {
				this.activeTab = tab
			},
			goDetail(optionId) {
				this.scrollTop = window.scrollY
				this.currentOptionId = optionId
				// this.vote_startsign = data.vote_startsign
				this.showDetail = true
			},
			onDetailBack() {
				this.showDetail = false
				this.currentOptionId = ''
				this.$nextTick(() => {
					window.scroll(0, this.scrollTop)
				})
			},
			onDetailVoted(optionId) {
				this.updateVoteCount(optionId)
			},
			onVoteLimit() {
				this.sxflag = true
			},
			
			tijiao() {
				if (!this.form.zpname.trim()) {
					Toast('请输入作品名称')
					return
				}
				if (!this.form.username.trim()) {
					Toast('请输入姓名/单位名称')
					return
				}
				if (!this.form.idnum.trim()) {
					Toast('请输入身份证号码/社会信用代码')
					return
				}
				if (!this.form.cityname.trim()) {
					Toast('请选择地区')
					return
				}
				
				if (!this.form.phone.trim()) {
					Toast('请填写联系电话')
					return
				}
				if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
					Toast('请输入正确的手机号码')
					return
				}
				if (!this.form.subcategory.trim()) {
					Toast('请选择作品类别')
					return
				}
				if (!this.form.zpurl) {
					Toast('请先上传作品')
					return
				}
				if(this.form.subcategory!='摄影作品'){
					if (!this.form.zpcoverimg) {
						Toast('请先上传作品封面')
						return
					}
				}else{
					this.form.zpcoverimg = this.form.zpurl
				}
				
				if (!this.form.zpintroduction.trim()) {
					Toast('请输入作品简介')
					return
				}
				
				this.uploading = true
				this.uploadProgress = '提交中...'
				submitEntry(this.form).then(res => {
					this.uploading = false
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code + '' === '1') {
						this.form = {
							zpname:"",
							isbn:"",
							username:"",
							idnum:"",
							cityname:"",
							phone:"",
							zpcategory:"",
							subcategory:"",
							zpcoverimg:"",
							zpurl:"",
							honor:"",
							buchongfile:"",
							zpintroduction:""
						}
						this.zpcategoryValue = null
						this.fileList=[];
						this.posterFileList=[];
						this.ryFileList=[];
						this.bcFileList=[];
						Toast('提交信息成功')
					} else {
						Toast(data.data || '提交失败')
					}
				}).catch(() => {
					this.uploading = false
					Toast('提交信息失败，请重试')
				})
			},
			handleVote(optionId) {
				if (isJiyun()) {
					Toast('请分享到微信客户端内打开链接参与投票')
					return
				}
				if (this.sxflag) {
					Toast('您今天已达投票上限')
					return
				}
				try {
					var captcha = new TencentCaptcha('190326154', (res) => {
						this.onCaptchaCallback(res, optionId)
					}, {
						userLanguage: 'zh-cn'
					})
					captcha.show()
				} catch (error) {
					this.loadErrorCallback(optionId)
				}
			},
			onCaptchaCallback(res, optionId) {
				if (res.ret === 0) {
					var params = {
						Ticket: res.ticket,
						Randstr: res.randstr,
						wxopenid: this.wxopenid,
						option_id: optionId,
						option_voteid: this.voteid
					}
					this.$api.submitVote(params).then(response => {
						var data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
						if (data.code == 1) {
							this.updateVoteCount(optionId)
							Toast('投票成功')
						} else {
							Toast(data.msg || '投票失败')
							if (data.msg && data.msg.indexOf('上限') > -1) {
								this.sxflag = true
							}
						}
					})
				}
			},
			loadErrorCallback(optionId) {
				var appid = '190326154'
				var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000)
				this.onCaptchaCallback({
					ret: 0,
					randstr: '@' + Math.random().toString(36).substr(2),
					ticket: ticket,
					errorCode: 1001,
					errorMessage: 'jsload_error'
				}, optionId)
			},
			updateVoteCount(optionId) {
				this.hotList.forEach(item => {
					if (item.option_id == optionId) {
						item.option_vnum = parseInt(item.option_vnum) + 1
					}
				})
			},
			onHotLoad() {
				if (this.hotSearchMode) {
					this.fetchHotSearchList()
				} else {
					this.fetchHotList()
				}
			},
			fetchHotList() {
				var params = {
					order: 'all',
					pagenow: this.hotPage,
					voteid: this.voteid
				}
				getVoteList(params).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					var list = data.data.list || []
					this.hotList = this.hotPage === 1 ? list : this.hotList.concat(list)
					this.vote_startsign = this.hotList[0].vote_startsign
					this.hotLoading = false
					if (list.length < 20 || this.hotPage >= data.data.pagecount) {
						this.hotFinished = true
					}
					this.hotPage++
				}).catch(() => {
					this.hotLoading = false
					this.hotFinished = true
				})
			},
			fetchHotSearchList() {
				var params = {
					pagenow: this.hotPage,
					keyword: this.hotKeyword,
					order: 'all',
					voteid: this.voteid
				}
				searchVoteList(params).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					var list = data.data.list || []
					this.hotList = this.hotPage === 1 ? list : this.hotList.concat(list)
					this.vote_startsign = this.hotList[0].vote_startsign
					this.hotLoading = false
					if (list.length < 20 || this.hotPage >= data.data.pagecount) {
						this.hotFinished = true
					}
					this.hotPage++
				}).catch(() => {
					this.hotLoading = false
					this.hotFinished = true
				})
			},
			onHotSearch() {
				this.hotSearchMode = true
				this.hotPage = 1
				this.hotList = []
				this.hotFinished = false
				this.hotLoading = true
				this.fetchHotSearchList()
			}
		}
	}
</script>

<style scoped>
	.home-page {
		min-height: 100vh;
	}

	.detail-wrapper {
		min-height: 100vh;
	}

	.page-bg {
		background: #304de7;
		background-size: 100% auto;
		background-repeat: repeat-y;
		min-height: 100vh;
		padding-bottom: 30px;
	}

	.top-img-view {
		width: 100%;
		position: relative;
		font-size: 0;
	}

	.top-img {
		width: 100%;
		display: block;
	}

	.tab-bar {
		display: flex;
		justify-content: space-around;
		padding: 0px 15px;
		align-items: center;
		position: absolute;
		bottom: 0px;
		left: 0;
		width: 100%;
	}

	.tab-img {
		width: 30%;
		cursor: pointer;
		transition: opacity 0.2s;
		touch-action: manipulation;
	}

	.tab-active {
		opacity: 1;
	}

	.tab-content {
		padding: 30px 0 10px;
	}

	.intro-section {
		text-align: center;
		/* padding: 0 15px; */
	}

	.form-title-section {
		padding: 15px 15px 0;
	}

	.form-title-wrapper {
		display: flex;
		align-items: center;
		background: linear-gradient(90deg, #1e40af, #3b82f6);
		padding: 12px 15px;
		border-radius: 8px;
	}

	.form-title-icon {
		width: 28px;
		height: 28px;
		margin-right: 10px;
	}

	.form-title-text {
		color: #ffffff;
		font-size: 1.1rem;
		font-weight: bold;
	}

	.form-section {
		width: 90%;
		margin: 0px auto;
	}

	.form-card {
		background-image: url(../assets/new/form_bg2.png);
		background-size: 100% auto;
		background-repeat: repeat-y;
		padding: 20px;
	}

	.form-item {
		margin-top: 12px;
		display: flex;
		align-items: center;
	}

	.form-item-label {
		color: #000;
		font-size: 1rem;
		font-weight: bold;
		width: 0;
		flex: 1;
		text-align: justify;
		    text-align-last: justify;
		position: relative;
		padding-right: 10px;
		
	}
	.form-item-label::after{
		position: absolute;
		top: 55%;
		right: 0;
		content: ':';
		transform: translateY(-50%);
	}
	.form-tip {
		color: #9ca1b4;
		font-size: 0.9rem;
		margin-top: 15px;
		line-height: 1.8;
		text-align: justify;
	}

	.form-upload-tip {
		color: #666666;
		font-size: 0.9rem;
		line-height: 1.5;
		
		margin-top: 10px;
		display: flex;
		align-items: start;
	}

	.form-intro-tip {
		color: #666666;
		font-size: 0.8rem;
		padding: 5px 5% 10px;
	}

	.input-div {
		width: 65%;
		margin-left: 10px;
	}

	.custom-input {
		background: #ffffff;
		border-radius: 10px;
		width: 100%;
		margin: 0 auto;
		padding-left: 10px;
		border: none;
		outline: none;
		height: 40px;
		font-size: 1rem;
		color: #000;
		
	}
	.custom-input::placeholder{
		color: #9ca1b4;
	}
	.inputsr{
		background-color: #0979ff;
		display: flex;
		align-items: center;
		padding: 3px;
		border-radius: 7px;
		margin-top: 12px;
	}
	.inputsr input{
		height: 40px;
		width: 0;
		flex: 1;
		border-radius: 7px;
		padding-left: 10px;
		border: none;
		outline: none;
		background-color: #f5f5f5;
		color: #000;
		font-size: 1rem;
	}
	.inputsr img{
		box-sizing: content-box;
		width: 35px;
		padding: 0 10px;
	}
	.custom-textarea {
		background: #ffffff;
		border-radius: 10px;
		margin: 0 auto;
	}

	.upload-area {
		background: #ffffff;
		border-radius: 8px;
		width: 30%;
		padding: 30px 0;
		text-align: center;
		min-height: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 0 2px #cbd5e1;
		cursor: pointer;
		touch-action: manipulation;
		margin-top: 15px;
	}

	.upload-placeholder {
		text-align: center;
		color: #3f3f3f;
		font-size: 2rem;
		font-weight: 300;
	}

	.upload-filename {
		font-size: 0.85rem;
		color: #333;
		word-wrap: break-word;
		padding: 0 15px;
	}

	.submit-btn {
		text-align: center;
		cursor: pointer;
		margin-top: 25px;
		touch-action: manipulation;
	}

	.search-section {
		padding: 0px 15px;
		background-image: url('@/assets/new/list_bg2.png');
		background-size: 100% auto;
		background-repeat: repeat-y;
	}

	.search-input-wrapper {
		position: relative;
		width: 90%;
		margin: 0 auto;
	}

	.search-icon {
		position: absolute;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		width: 24px;
		height: 24px;
		pointer-events: none;
	}

	
	.list-inner {
		padding: 15px 12px 0;
		background-image: url('@/assets/new/list_bg2.png');
		background-size: 100% auto;
		background-repeat: repeat-y;

	}

	.list-container {
		font-size: 0;
	}
	.xuhao {
		border-radius: 5px 5px 0 0;
		color: #fffffe;
		font-size: 1.1rem;
		padding: 1px 0 1px 5px;
		/* font-weight: bold; */
		/* white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis; */
	}
	.listdiv {
		position: relative;
		display: inline-block;
		width: 49%;
		border-radius: 5px;
		background-color: #80b1ff;
		padding-bottom: 15px;
		margin-top: 15px;
		vertical-align: top;
		overflow: hidden;
	}

	.coverss {
		background-position: center;
		background-size: cover;
		display: inline-block;
		width: 100%;
		height: 0;
		padding-bottom: 75%;
		cursor: pointer;
		touch-action: manipulation;
	}

	.list-info {
		padding: 10px 10px 5px;
	}

	.titlewz {
		font-size: 1rem;
		margin-top: 3px;
		color: #fffffe;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: center;
		font-weight: 500;
	}

	.vote-btn {
		width: 55%;
		margin-top: 10px;
		cursor: pointer;
		touch-action: manipulation;
	}

	.upload-overlay {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.upload-text {
		color: #fff;
		font-size: 1rem;
		margin-top: 10px;
	}
	.piaodiv {
		font-size: 1rem;
		margin-top: 5px;
		color: #ffd700;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		
	}
	.van-cell{
		padding: 0 !important;
	}
</style>